module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoB.018066f.ttf";